import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store/store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import(/* webpackChunkName: "about" */ './views/About.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/aviso',
            name: 'aviso',
            component: () => import('./views/Aviso.vue'),
        },
        {
            path: '/vinateria',
            name: 'vinateria',
            component: () => import('./views/Vinateria.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/licoreria',
            name: 'licoreria',
            component: () => import('./views/Licoreria.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/cerveceria',
            name: 'cerveceria',
            component: () => import('./views/Cerveceria.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/restaurante',
            name: 'restaurante',
            component: () => import('./views/Restaurante.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/gourmet',
            name: 'gourmet',
            component: () => import('./views/Gourmet.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/privacidad',
            name: 'privacidad',
            component: () => import('./views/PoliticasPrivacidad.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/sucursales',
            name: 'sucursales',
            component: () => import('./views/Sucursales.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/centrosconsumo',
            name: 'centrosconsumo',
            component: () => import('./views/CentrosDeConsumo.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/contacto',
            name: 'contacto',
            component: () => import('./views/Contacto.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/promociones',
            name: 'promociones',
            component: () => import('./views/Promociones.vue'),
            meta: {
                authRequired: true
            }
        },
        { path: '/redirect-me', redirect: { name: 'home' } },
        { path: '*', redirect: '/' }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
        if (!store.state.bAutorizado) {
            next({ path: '/aviso' });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;